import React, { FC } from 'react';

import Rive, { Fit, Layout } from '@rive-app/react-canvas';
import clsx from 'clsx';

import { useThemeMode } from '~/contexts/ThemeModeContext';

import styles from './styles.module.scss';
import { getLoaderAnimationSrc } from './utils';

type Props = {
  isLoading?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const LOADER_LAYOUT = new Layout({
  fit: Fit.Cover,
});

const Loader: FC<Props> = ({ className, isLoading = true, children }) => {
  const { themeMode } = useThemeMode();
  const animationSrc = getLoaderAnimationSrc(themeMode);

  return isLoading ? (
    <div className={styles.loader_wrapper}>
      <div className={clsx(styles.animation, className)}>
        <Rive
          layout={LOADER_LAYOUT}
          shouldResizeCanvasToContainer
          src={animationSrc}
        />
      </div>
    </div>
  ) : (
    <>{children}</>
  );
};

export default Loader;
